import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { EmailActivityPage } from '../../../../shared/email-activity/email-activity-page'
import { RoleSysSendgridEvent } from '../../../../role/components/role-sys'
import { NoAccess } from '../../../../role/components/no-access'

// Email activity in the staff Internal tools: every organization (the
// page's `system` view, which the server grants to SYS_SENDGRID_EVENT read
// only). It replaced the SendGrid events page, whose old addresses land here.
export const LayoutEmailActivity = () => {
  return (
    <React.Fragment>
      {/* Gated by its sidebar permission too, so a typed URL without it
          shows NoAccess. */}
      <Route path="/admin/email-activity">
        <RoleSysSendgridEvent accessRead fallback={<NoAccess what="email activity" />}>
          <EmailActivityPage system />
        </RoleSysSendgridEvent>
      </Route>
      <Route path="/admin/sendgrid-event"><Redirect to="/admin/email-activity" /></Route>
    </React.Fragment>
  )
}
